import { RoleViewModel, RoleTypes } from '../models/role';

export function RoleService() {
  const rolesData = [
    new RoleViewModel(RoleTypes.ENDPOINT_ADMIN, 'Администратор окружения', 'Полный контроль над всеми ресурсами окружения', []),
    new RoleViewModel(RoleTypes.OPERATOR, 'Оператор', 'Оперативное управление существующими ресурсами окружения', []),
    new RoleViewModel(RoleTypes.HELPDESK, 'Служба поддержки', 'Доступ только для чтения ко всем ресурсам окружения', []),
    new RoleViewModel(RoleTypes.READ_ONLY, 'Пользователь только для чтения', 'Доступ только для чтения к назначенным ресурсам окружения', []),
    new RoleViewModel(RoleTypes.STANDARD, 'Обычный пользователь', 'Полный контроль над назначенными ресурсами окружения', []),
  ];

  return {
    roles,
  };

  function roles() {
    return rolesData;
  }
}
